"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = Grid;
var react_1 = __importStar(require("react"));
var row_ctx_1 = require("./contexts/row_ctx");
var modal_1 = require("./modal");
var order_mod_1 = require("./forms/order_mod");
var cun_1 = require("./forms/cun");
var eso_1 = require("./forms/eso");
var pagenum_1 = require("./forms/pagenum");
var search_1 = require("./forms/search");
var report_1 = require("./forms/report");
var hpv_1 = require("./forms/hpv");
var grid_ctx_1 = require("./contexts/grid_ctx");
var export_1 = require("./forms/export");
var order_add_1 = require("./forms/order_add");
var order_batch_add_1 = require("./forms/order_batch_add");
var gcm_1 = require("./forms/gcm");
var lcm_1 = require("./forms/lcm");
var hpvcun_1 = require("./forms/hpvcun");
var ad_1 = require("./forms/ad");
var pc_1 = require("./forms/pc");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var hospital_1 = require("./forms/hospital");
var product_1 = require("./forms/product");
var report_batch_add_1 = require("./forms/report_batch_add");
function ResultForm() {
    var localRecord = (0, react_1.useContext)(row_ctx_1.RowContext).localRecord;
    switch (localRecord.product_id) {
        case "cun":
            return react_1.default.createElement(cun_1.FormCun, null);
        case "eso":
            return react_1.default.createElement(eso_1.FormEso, null);
        case "hpv":
            return react_1.default.createElement(hpv_1.FormHpv, null);
        case "hpvcun":
            return react_1.default.createElement(hpvcun_1.FormHpvcun, null);
        case "gcm":
            return react_1.default.createElement(gcm_1.FormGcm, null);
        case "lcm":
            return react_1.default.createElement(lcm_1.FormLcm, null);
        case "ad":
            return react_1.default.createElement(ad_1.FormAd, null);
        case "pc":
            return react_1.default.createElement(pc_1.FormPc, null);
        default:
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
function isUploaded(uploaded_at) {
    return !!uploaded_at && uploaded_at.length > 0;
}
function isRed(positive) {
    return [true, "弱阳性", "强阳性", "中风险", "高风险", "极高风险"].includes(positive);
}
function getUploadStatus(uploaded_at) {
    return isUploaded(uploaded_at) ? "已上传" : "未上传";
}
function getResult(positive) {
    if (positive === true) {
        return "阳性";
    }
    if (positive === false) {
        return "阴性";
    }
    return positive || "";
}
function isRowSpan(product_id) {
    return ["gcm", "lcm"].includes(product_id);
}
function getTestValue(shouldMerge) {
    var localRecord = (0, react_1.useContext)(row_ctx_1.RowContext).localRecord;
    var header = localRecord.report_id ? localRecord.test_value[0] || [] : [];
    var data = localRecord.report_id ? localRecord.test_value[1] || [] : [];
    return (react_1.default.createElement("table", { className: "compact-table w-full border-collapse" },
        react_1.default.createElement("thead", null,
            react_1.default.createElement("tr", null, header.map(function (value, index) { return (react_1.default.createElement("td", { key: "header-".concat(index) }, value)); }))),
        react_1.default.createElement("tbody", null, localRecord.product_id == "ad"
            ? data.map(function (_a, index) {
                var target1 = _a[0], target2 = _a[1], target3 = _a[2], reference = _a[3], crs = _a[4];
                return (react_1.default.createElement("tr", { key: "".concat(target1, "-").concat(index) },
                    react_1.default.createElement("td", { className: "border-b border-gray-200" }, target1),
                    react_1.default.createElement("td", { className: "border-b border-gray-200" }, target2),
                    react_1.default.createElement("td", { className: "border-b border-gray-200" }, target3),
                    react_1.default.createElement("td", { className: "border-b border-gray-200" }, reference),
                    react_1.default.createElement("td", { className: "border-b border-gray-200" }, crs)));
            })
            : data.map(function (_a, index) {
                var gene = _a[0], value = _a[1], reference = _a[2];
                return (react_1.default.createElement("tr", { key: "".concat(gene, "-").concat(index) },
                    react_1.default.createElement("td", { className: "border-b border-gray-200" }, gene),
                    index === 0 || !shouldMerge ? (react_1.default.createElement("td", { rowSpan: shouldMerge
                            ? localRecord.test_value.length
                            : undefined, className: "border-b border-gray-200" }, value)) : null,
                    index === 0 || !shouldMerge ? (react_1.default.createElement("td", { rowSpan: shouldMerge
                            ? localRecord.test_value.length
                            : undefined, className: "border-b border-gray-200" }, reference)) : null));
            }))));
}
function getUploadedResults() {
    var localRecord = (0, react_1.useContext)(row_ctx_1.RowContext).localRecord;
    var header = localRecord.uploaded_results
        ? localRecord.uploaded_results[0] || []
        : [];
    var data = localRecord.uploaded_results
        ? localRecord.uploaded_results[1] || []
        : [];
    return (react_1.default.createElement("table", { className: "compact-table w-full border-collapse" },
        react_1.default.createElement("thead", null,
            react_1.default.createElement("tr", null, header.map(function (value, index) { return (react_1.default.createElement("td", { key: "header-".concat(index) }, value)); }))),
        react_1.default.createElement("tbody", null,
            react_1.default.createElement("tr", null, data.map(function (value, index) { return (react_1.default.createElement("td", { key: index, className: "border-b border-gray-200" }, Array.isArray(value)
                ? value.map(function (imgId, imgIndex) { return (react_1.default.createElement("a", { key: imgIndex, href: "/xdh1-api/report/download?report_id=".concat(imgId, "&fmt=jpg"), target: "_blank" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faImage, className: "w-5 h-5" }))); })
                : value)); })))));
}
function Row() {
    var localRecord = (0, react_1.useContext)(row_ctx_1.RowContext).localRecord;
    var shouldMerge = isRowSpan(localRecord.product_id);
    return (react_1.default.createElement("tr", { className: "".concat(isRed(localRecord.positive) ? "positive-results" : "") },
        react_1.default.createElement("td", { className: "fixed-cell first-fixed" }, localRecord.index),
        react_1.default.createElement("td", { className: "monospaced" }, localRecord.order_id),
        react_1.default.createElement("td", null, localRecord.hospital),
        react_1.default.createElement("td", null, localRecord.doctor),
        react_1.default.createElement("td", null, localRecord.product_name),
        react_1.default.createElement("td", null, localRecord.sample_type),
        react_1.default.createElement("td", { className: "monospaced" }, localRecord.sampling_date),
        react_1.default.createElement("td", { className: "monospaced" }, localRecord.receipt_date),
        react_1.default.createElement("td", { className: "monospaced" }, localRecord.test_date),
        react_1.default.createElement("td", { className: "monospaced" }, localRecord.sample_id),
        react_1.default.createElement("td", { className: "monospaced" }, localRecord.patient_id),
        react_1.default.createElement("td", null, localRecord.patient_name),
        react_1.default.createElement("td", null, localRecord.patient_gender),
        react_1.default.createElement("td", null, localRecord.patient_age),
        react_1.default.createElement("td", { className: "monospaced" }, localRecord.phone),
        react_1.default.createElement("td", { className: "monospaced" }, localRecord.resident_id),
        react_1.default.createElement("td", { className: "monospaced" }, localRecord.tj_id),
        react_1.default.createElement("td", { className: "monospaced" }, localRecord.check_id),
        react_1.default.createElement("td", { className: "monospaced" }, getTestValue(shouldMerge)),
        react_1.default.createElement("td", { className: "".concat(isRed(localRecord.positive) ? "monospaced positive-results-value" : "monospaced") }, getResult(localRecord.positive)),
        react_1.default.createElement("td", { className: "monospaced" }, localRecord.report_date),
        react_1.default.createElement("td", { className: "monospaced" }, localRecord.uploaded_at),
        react_1.default.createElement("td", { className: "monospaced" }, getUploadedResults()),
        react_1.default.createElement("td", { className: "upload-status ".concat(isUploaded(localRecord.uploaded_at) ? "uploaded" : "not-uploaded") }, getUploadStatus(localRecord.uploaded_at)),
        react_1.default.createElement("td", { className: "fixed-cell last-fixed" },
            react_1.default.createElement(modal_1.ModalButtonSuite, { title: "\u4FEE\u6539\u8BA2\u5355" },
                react_1.default.createElement(order_mod_1.OrderForm, null)),
            react_1.default.createElement(modal_1.ModalButtonSuite, { title: "\u4FEE\u6539\u7ED3\u679C" },
                react_1.default.createElement(ResultForm, null)),
            react_1.default.createElement(report_1.ReportButtonGroup, null))));
}
function Grid() {
    var localRecords = (0, react_1.useContext)(grid_ctx_1.GridContext).localRecords;
    var trs = localRecords.map(function (record) {
        return (react_1.default.createElement(row_ctx_1.RowProvider, { localRecord: record, key: record.id },
            react_1.default.createElement(Row, null)));
    });
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "grid zmsk-grid" },
            react_1.default.createElement(modal_1.ModalButtonSuite, { title: "\u65B0\u589E\u8BA2\u5355" },
                react_1.default.createElement(order_add_1.OrderAddForm, null)),
            react_1.default.createElement(modal_1.ModalButtonSuite, { title: "\u6279\u91CF\u5BFC\u5165\u8BA2\u5355" },
                react_1.default.createElement(order_batch_add_1.OrderBatchAddForm, null)),
            react_1.default.createElement(modal_1.ModalButtonSuite, { title: "\u6279\u91CF\u5BFC\u5165\u62A5\u544A" },
                react_1.default.createElement(report_batch_add_1.ReportBatchAddForm, null)),
            react_1.default.createElement(export_1.ExportButton, { fmt: "csv" }, "\u5BFC\u51FACSV"),
            react_1.default.createElement(export_1.ExportButton, { fmt: "xlsx" }, "\u5BFC\u51FAExcel"),
            react_1.default.createElement(modal_1.ModalButtonSuite, { title: "\u9001\u68C0\u5355\u4F4D\u7BA1\u7406" },
                react_1.default.createElement(hospital_1.FormHospital, null)),
            react_1.default.createElement(modal_1.ModalButtonSuite, { title: "\u68C0\u6D4B\u9879\u76EE\u7BA1\u7406" },
                react_1.default.createElement(product_1.ProductForm, null)),
            react_1.default.createElement(search_1.SearchForm, null)),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "grid zmsk-grid scrollable-table-container" },
                react_1.default.createElement("table", { id: "recordsTable", className: "zmsk-table scrollable-table" },
                    react_1.default.createElement("thead", null,
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("th", { className: "fixed-cell first-fixed" }, "\u5E8F\u53F7"),
                            react_1.default.createElement("th", null, "\u8BA2\u5355\u7F16\u53F7"),
                            react_1.default.createElement("th", null, "\u9001\u68C0\u5355\u4F4D"),
                            react_1.default.createElement("th", null, "\u9001\u68C0\u533B\u751F"),
                            react_1.default.createElement("th", null, "\u68C0\u6D4B\u9879\u76EE"),
                            react_1.default.createElement("th", null, "\u6837\u672C\u7C7B\u578B"),
                            react_1.default.createElement("th", null, "\u91C7\u6837\u65E5\u671F"),
                            react_1.default.createElement("th", null, "\u63A5\u6536\u65E5\u671F"),
                            react_1.default.createElement("th", null, "\u68C0\u9A8C\u65E5\u671F"),
                            react_1.default.createElement("th", null, "\u6837\u672C\u7F16\u53F7"),
                            react_1.default.createElement("th", null, "\u60A3\u8005\u7F16\u53F7"),
                            react_1.default.createElement("th", null, "\u60A3\u8005\u59D3\u540D"),
                            react_1.default.createElement("th", null, "\u60A3\u8005\u6027\u522B"),
                            react_1.default.createElement("th", null, "\u60A3\u8005\u5E74\u9F84"),
                            react_1.default.createElement("th", null, "\u8054\u7CFB\u7535\u8BDD"),
                            react_1.default.createElement("th", null, "\u8EAB\u4EFD\u8BC1"),
                            react_1.default.createElement("th", null, "\u4F53\u68C0ID"),
                            react_1.default.createElement("th", null, "\u9879\u76EEID"),
                            react_1.default.createElement("th", null, "\u68C0\u6D4B\u503C"),
                            react_1.default.createElement("th", null, "\u68C0\u6D4B\u7ED3\u679C"),
                            react_1.default.createElement("th", null, "\u62A5\u544A\u65E5\u671F"),
                            react_1.default.createElement("th", null, "\u4E0A\u4F20\u65F6\u95F4"),
                            react_1.default.createElement("th", null, "\u4E0A\u4F20\u7ED3\u679C"),
                            react_1.default.createElement("th", null, "\u72B6\u6001"),
                            react_1.default.createElement("th", { className: "fixed-cell last-fixed" }, "\u64CD\u4F5C"))),
                    react_1.default.createElement("tbody", { id: "recordsBody" }, trs)))),
        react_1.default.createElement("div", { className: "scroll-hint" },
            react_1.default.createElement("span", null, "\u2190 \u5DE6\u53F3\u6ED1\u52A8 \u2192")),
        react_1.default.createElement("div", { className: "grid zmsk-grid" },
            react_1.default.createElement(pagenum_1.PageNumSuite, null))));
}
